export const legalAddress = {
    companyName: "Digitaloom, Inc.",
    registryCode: "2955726",
    legislationState: "state Delaware",
    address: "State of Delaware 8 The Green, Ste R, City of Dover, DE Country of Kent, 19901",
};
